"use client";

import type { CoreServiceWithPlans } from "@/app/_lib/db/core-service";
import type { SolutionWithInclude } from "@/app/_lib/db/solutions";

export interface ChipItem {
  label: string;
  id: string;
  type: "service" | "solution";
}

interface Props {
  services: Pick<CoreServiceWithPlans, "id" | "title">[];
  solutions: Pick<SolutionWithInclude, "id" | "headTitle">[];
  onSelect: (item: ChipItem) => void;
}

export function ServiceChips({ services, solutions, onSelect }: Props) {
  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {services.map((s) => (
        <button
          key={s.id}
          onClick={() => onSelect({ label: s.title, id: s.id, type: "service" })}
          className="px-3 py-1.5 text-xs rounded-full border border-primary text-primary bg-accent hover:bg-primary hover:text-white transition-colors duration-150 font-medium"
        >
          {s.title}
        </button>
      ))}
      {solutions.map((sol) => (
        <button
          key={sol.id}
          onClick={() =>
            onSelect({ label: sol.headTitle, id: sol.id, type: "solution" })
          }
          className="px-3 py-1.5 text-xs rounded-full border border-border text-foreground bg-accent hover:bg-accent/70 transition-colors duration-150 font-medium"
        >
          {sol.headTitle}
        </button>
      ))}
    </div>
  );
}
